import { makeObservable, observable, action, runInAction } from 'mobx';
import { supportAPI } from '@api/Support.api';
import { RootStore } from './Root.store';

export default class SupportStore {
    @observable
    loading: boolean;

    @observable
    serverError: boolean;

    @observable
    operationSuccess: boolean;

    constructor(private rootStore: RootStore) {
        this.setDefault();
        makeObservable(this);
    }

    @action
    setDefault() {
        this.loading = false;
        this.serverError = false;
    }

    @action
    async createReport(topic: string, content: string) {
        const token = this.rootStore.user.token;
        if (!token) return;
        this.loading = true;
        try {
            const res = await supportAPI.create(token, topic, content);
            if (res.result === 'success') {
                runInAction(() => {
                    this.loading = false;
                    this.operationSuccess = true;
                });
            } else {
                runInAction(() => {
                    this.loading = false;
                    this.serverError = true;
                });
            }
        } catch (e) {
            runInAction(() => {
                this.loading = false;
                this.serverError = true;
            });
        }
    }

    @action
    resetOperationSuccess() {
        this.operationSuccess = false;
    }

    @action
    resetServerError() {
        this.serverError = false;
    }
}
